<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <iselect dictcode="project_tags" style="width:200px;margin-right:10px" v-model="selectTags"></iselect>
      <Button icon="md-search" type="primary" @click="search">查询</Button>
      <Table
        style="margin-top:10px"
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        @on-row-click="rowSelect"
      ></Table>
    </Card>
  </div>
</template>

<script>
import iselect from "../../components/iselect";
export default {
  components: {
    iselect,
  },
  data() {
    return {
      selectTags: "",
      projectlist: [],
      tdata: {
        keyword: "",
        //数据总量
        total: 0,
        //每页数量
        page_size: 15,
        //当前分页索引
        current_index: 1,
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "项目名称",
            key: "projectname",
          },
          {
            title: "项目经理",
            key: "pmname",
          },
        ],
      },
    };
  },
  methods: {
    search() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/queryprojectsbytags",
        params: {
          tag: this.selectTags,
        },
        success: function (data) {
          _this.tdata.current_data = [];
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            _this.tdata.current_data.push({
              projectguid: item[0],
              projectname: item[1],
              pmname: item[2],
            });
          }
        },
      });
    },
    rowSelect(row) {
      window.open("#/projectoverview/" + row.projectguid);
    },
  },
  mounted() {},
};
</script>